import script from "./FileCollect.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileCollect.vue?vue&type=script&lang=ts&setup=true"

import "./FileCollect.vue?vue&type=style&index=0&id=0c7e8696&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7e8696"]])

export default __exports__